var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carddraw-module"},[_c('div',{staticClass:"k-carddraw",style:(_vm.aStyle)},[_c('div',{staticClass:"lottery-num",style:({
        fontSize: `${_vm.$unit(_vm.num.fontSize)}`,
        color: `${_vm.num.fontColor}`,
        bottom: `${_vm.$unit(_vm.num.bottom)}`
      })},[_vm._v(" 剩余"+_vm._s(_vm.prizeNum || 0)+"次抽奖机会 ")]),_c('div',{staticClass:"btn-history",style:({
        fontSize: `${_vm.$unit(_vm.history.fontSize)}`,
        color: `${_vm.history.fontColor}`,
        bottom: `${_vm.$unit(_vm.history.bottom)}`
      }),on:{"click":_vm.openPrizeRecord}},[_vm._v(" 查看中奖记录 ")]),_c('base-redpack',{ref:"redDrawPrize",staticClass:"wrapper",style:({
        bottom: `${_vm.$unit(_vm.draw.bgBottom)}`,
        right: `${_vm.$unit(_vm.draw.bgLeft)}`,
        left: `${_vm.$unit(_vm.draw.bgLeft)}`
      }),attrs:{"draw":_vm.draw,"viewStatus":_vm.viewStatus},on:{"end-turns":_vm.endTurns,"start-turns":_vm.startTurns},scopedSlots:_vm._u([{key:"item",fn:function(scope){return [_c('img',{attrs:{"src":scope.item}})]}}])})],1),(_vm.state.isShowDialogRedEffect)?_c('RedpackEffect',{attrs:{"img":_vm.draw}}):_vm._e(),(_vm.marquee.scrollSwitch)?_c('div',{staticClass:"marquee-box",style:(_vm.pStyle)},[_c('div',{staticClass:"marquee-scroll",style:({
        bottom: `${_vm.$unit(_vm.marquee.bottom)}`
      })},[_c('scroll-marquee',{attrs:{"speed":10,"standTime":2000,"list":_vm.scrollPrizes,"marquee":_vm.marquee}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }